import styled from 'styled-components';

export const ProcessingSpinnerWrapper = styled.section`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;
